import React from 'react';
import { useSelector } from 'react-redux';
import {
  HomeownersPolicyName,
  isCommitmentName,
  isTaxCertificateName,
  LendersPolicyNames,
  LongFormLendersPolicyNames,
  OwnersPolicyNames,
  ShortFormLendersPolicyNames,
} from 'types/order/documents/IDocumentCategoryType';
import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { RootStore } from '../../../store/types';
import { TitleSearchReportPage } from './TitleSearchReportPage';

export const editableDocumentCategories: string[] = Object.values(OwnersPolicyNames)
  .concat(Object.values(LongFormLendersPolicyNames))
  .concat(Object.values(LendersPolicyNames))
  .concat(Object.values(ShortFormLendersPolicyNames))
  .concat(HomeownersPolicyName);

export const findDocumentByTypes = (
  fn: (name: string) => unknown,
  documentList?: IStandardDocumentVersionData[] | undefined
): IStandardDocumentVersionData | undefined => {
  return (documentList || []).find((doc) => fn(doc.category));
};

export const commitmentEditable = (
  editableCategories: string[],
  documentList?: IStandardDocumentVersionData[] | undefined
): boolean => {
  if (!documentList || documentList.length === 0) return false;
  const nonEditableCategories = documentList.filter((doc) => !editableCategories.includes(doc.category));
  return nonEditableCategories.length === 0;
};

export interface ITitleSearchReportContainerProps {
  orderId: string;
}

export const TitleSearchReportContainer: React.FC<ITitleSearchReportContainerProps> = ({ orderId }) => {
  const { documents } = useSelector(({ order }: RootStore) => order.documents.adminDocuments);
  const { titleReport, titleReportExist } = useSelector(({ order }: RootStore) => order.titleReport);

  const commitmentDocument = findDocumentByTypes(isCommitmentName, documents[orderId]);
  const taxCertDocument = findDocumentByTypes(isTaxCertificateName, documents[orderId]);
  const isEditable = commitmentEditable(editableDocumentCategories, documents[orderId]);

  return (
    <TitleSearchReportPage
      titleReport={titleReport}
      titleReportExist={titleReportExist[orderId]}
      commitmentDocument={commitmentDocument}
      orderId={orderId}
      commitmentEditable={isEditable}
      taxCertDocument={taxCertDocument}
    />
  );
};
